import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getConsumerType } from 'Services/Applications/Customer';
import { CONSUMER_TYPE } from 'Utils/queries';

type Data = Awaited<ReturnType<typeof getConsumerType>>['data'];

export default function useGetConsumerType(options: UseQueryOptions<Data> = {}) {
  return useQuery<Data>([CONSUMER_TYPE], async () => {
    const { data } = await getConsumerType();

    return data;
  }, options);
}
